import { IncomingMessage } from 'http';

import { CustomError, fechFromBPartsApi } from '../utils';

export const passwordReset = async (
  variables: TSaveResquest
): Promise<void> => {
  const response = await fechFromBPartsApi(
    `/${variables.locale}/shop/accounts/password-reset`,
    {
      method: 'post',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', variables.csrftoken],
        ['b-origin', process.env.NEXT_PUBLIC_TENANT || '1'],
      ]),
      credentials: 'include',
      body: JSON.stringify(variables.formData),
    }
  );

  if (response.status === 204) {
    return;
  }
  let json;
  try {
    json = await response.json();
  } catch (error) {
    throw { serverError: error };
  }

  if (!response.ok) {
    throw json;
  }
  return;
};

export const passwordResetTokenValidation = async (
  {
    locale = 'en',
    token,
  }: {
    locale?: string;
    token: string;
  },
  req?: IncomingMessage
): Promise<boolean> => {
  const response = await fechFromBPartsApi(
    `/${locale}/shop/accounts/password-reset-confirm?token=${encodeURI(token)}`,
    {
      credentials: 'include',
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
    }
  );

  if (response.status == 200) {
    return true;
  } else if (response.status == 404) {
    return false;
  } else {
    throw new CustomError({
      status: 500,
      message: 'Unexpected API response',
    });
  }
};

export const passwordResetSave = async (
  variables: TSaveResquest
): Promise<void> => {
  const response = await fechFromBPartsApi(
    `/${variables.locale}/shop/accounts/password-reset-confirm`,
    {
      method: 'post',
      headers: new Headers([
        ['Content-Type', 'application/json'],
        ['X-CSRFToken', variables.csrftoken],
      ]),
      credentials: 'include',
      body: JSON.stringify(variables.formData),
    }
  );

  if (response.status === 204) {
    return;
  }
  let json;
  try {
    json = await response.json();
  } catch (error) {
    throw { serverError: error };
  }

  if (!response.ok) {
    throw json;
  }
  return;
};
